<template>
    <section>
        <div v-if="loading && !item">
            <Loading />
        </div>
        <div v-else>
            <ProfileNav></ProfileNav>
            <RecipientProfile :model="item" :medals="medalSets(item)"></RecipientProfile>
            <section id="medals" class="card-container">
                <h2>{{ $t('recipient_detail_page.decorations_title') }}</h2>
                <ul class="cards medal-sets">
                    <MedalSet
                        v-for="medalSet in medalSets(item)"
                        v-bind:key="medalSet.NumArtifactNo"
                        :model="medalSet"
                        :medals="medals">
                    </MedalSet>
                </ul>
            </section>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

import { medal_sets } from '@/models/medal'
import { recipient_name } from '@/models/recipient'
import { recipient_thumbnail_url } from '@/models/recipient'
import { recipient_biography } from '@/models/recipient'

import Loading from '@/components/Loading'
import MedalSet from "@/components/MedalSet"
import ProfileNav from "@/components/ProfileNav"
import RecipientProfile from "@/components/RecipientProfile"

export default {
    components: {
        Loading,
        RecipientProfile,
        MedalSet,
        ProfileNav
    },
    computed: {
        ...mapGetters({
            'item': 'recipients/item',
            'loading': 'recipients/item_loading',
            'medals': 'medals/list_results'
        }),
        meta_description() {
            let desc = '';
            if (this.item) {
                let longDesc = recipient_biography(this.item);
                desc = longDesc.slice(3, 97) + '...';
            }
            return desc;
        },
        meta_img() {
            let imgUrl = '';
            if (this.item) {
                imgUrl = recipient_thumbnail_url(this.item);
                if (imgUrl.includes('svg')) {
                    imgUrl = window.location.host + imgUrl.slice(2);
                }
            }
            return imgUrl;
        },
        meta_title() {
            return this.item ? recipient_name(this.item) : '-';
        }
    },
    head: {
        title: function() {
            return {
                inner: this.meta_title,
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.meta_description, id: 'desc'},

                {property: 'og:title', content: `${this.meta_title} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.meta_description, id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: this.meta_img, id: 'og-image'}
            ]
        }
    },
    methods: {
        back: (el => {
            window.history.back()
        }),
        name: (item => {
            return recipient_name(item)
        }),
        medalSets: (item => {
            return medal_sets(item)
        }),
    },
    async beforeDestroy() {
        await this.$store.dispatch("recipients/null_item")
    },
    async mounted() {
        await this.$store.dispatch("recipients/fetch", {
            locale: this.$i18n.locale,
            slug: this.$route.params.slug
        })

        await this.$store.dispatch("medals/fetch_list", {
            locale: this.$i18n.locale
        })

        this.$emit('updateHead')
    }
}
</script>